import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=5f6a03b6&scoped=true&"
import script from "./ResultDetail.vue?vue&type=script&lang=js&"
export * from "./ResultDetail.vue?vue&type=script&lang=js&"
import style0 from "./ResultDetail.vue?vue&type=style&index=0&id=5f6a03b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a03b6",
  null
  
)

export default component.exports